"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
var intl_utils_1 = require("@formatjs/intl-utils");
if (!_1.isUnitSupported('bit')) {
    intl_utils_1.defineProperty(Intl, 'NumberFormat', { value: _1.NumberFormat });
    intl_utils_1.defineProperty(Number.prototype, 'toLocaleString', {
        value: function toLocaleString(locales, options) {
            return _1.toLocaleString(this, locales, options);
        },
    });
}
